export const Icons = [
    {
        id:1,
        img: <i class="fa-brands fa-square-facebook fa-2x"></i>,
        link:"https://facebook.com",
        title:"facebook"
    },
     {
        id:2,
        img: <i class="fa-brands fa-square-instagram fa-2x"></i>,
        link:"https://instagram.com",
        title:"facebook"
    },
     {
        id:1,
        img: <i class="fa-brands fa-square-twitter fa-2x"></i>,
        link:"https://twitter.com",
        title:"facebook"
    },
     {
        id:1,
        img: <i class="fa-brands fa-square-youtube fa-2x"></i>,
        link:"https://youtube.com",
        title:"facebook"
    }
];
